import { SVGProps } from "react";

const Medal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="vuesax/linear/medal">
      <g id="vuesax/linear/medal_2">
        <g id="medal">
          <path
            id="Vector"
            d="M12 15C15.7279 15 18.75 12.0899 18.75 8.5C18.75 4.91015 15.7279 2 12 2C8.27208 2 5.25 4.91015 5.25 8.5C5.25 12.0899 8.27208 15 12 15Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M7.52365 13.5198L7.51367 20.8998C7.51367 21.7998 8.14368 22.2398 8.92368 21.8698L11.6037 20.5999C11.8237 20.4899 12.1937 20.4899 12.4137 20.5999L15.1037 21.8698C15.8737 22.2298 16.5137 21.7998 16.5137 20.8998V13.3398"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <g id="Group">
        <path
          id="Vector_3"
          d="M12.4338 6.35846L12.8748 7.24985C12.933 7.376 13.0911 7.49372 13.2243 7.51054L14.023 7.6451C14.5305 7.72919 14.6553 8.10759 14.2893 8.4692L13.6652 9.0999C13.5571 9.20922 13.4988 9.41105 13.5321 9.55401L13.7068 10.3277C13.8483 10.9416 13.5238 11.177 12.9913 10.8575L12.2425 10.4118C12.1093 10.3277 11.8847 10.3277 11.7516 10.4118L11.0027 10.8575C10.4702 11.177 10.1457 10.9416 10.2872 10.3277L10.4619 9.55401C10.4952 9.41105 10.4369 9.20081 10.3288 9.0999L9.71307 8.47761C9.34698 8.1076 9.46346 7.73758 9.97932 7.65349L10.7781 7.51896C10.9112 7.49373 11.0693 7.376 11.1275 7.25827L11.5685 6.36686C11.8098 5.87911 12.1925 5.87913 12.4338 6.35846Z"
          stroke="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default Medal;
